var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_15943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.79 20.5H5V10.5H19V13.46C19 14.35 20.08 14.8 20.71 14.17C20.9 13.98 21 13.73 21 13.46V6.5C21 5.4 20.1 4.5 19 4.5H18V3.5C18 2.95 17.55 2.5 17 2.5C16.45 2.5 16 2.95 16 3.5V4.5H8V3.5C8 2.95 7.55 2.5 7 2.5C6.45 2.5 6 2.95 6 3.5V4.5H5C3.89 4.5 3.01 5.4 3.01 6.5L3 20.5C3 21.6 3.89 22.5 5 22.5H11.79C12.68 22.5 13.13 21.42 12.5 20.79C12.31 20.61 12.06 20.5 11.79 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1508 18.5C20.1508 19.0724 19.6885 19.5346 19.1162 19.5346L17.8247 19.5346L17.8247 20.8261C17.8247 21.3985 17.3624 21.8608 16.79 21.8608C16.2177 21.8608 15.7554 21.3985 15.7554 20.8261L15.7554 19.5346L14.4639 19.5346C13.8916 19.5346 13.4293 19.0724 13.4293 18.5C13.4293 17.9276 13.8916 17.4654 14.4639 17.4654L15.7554 17.4654L15.7554 16.1739C15.7554 15.6015 16.2177 15.1392 16.79 15.1392C17.3624 15.1392 17.8247 15.6015 17.8247 16.1739L17.8247 17.4654L19.1162 17.4654C19.6885 17.4654 20.1508 17.9276 20.1508 18.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_15943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEventIcon);
export default __webpack_public_path__ + "static/media/CreateEventIcon.c9a48ec2843668fe92995eb6d3e033ae.svg";
export { ForwardRef as ReactComponent };